module.exports = __webpack_public_path__ + "img/C06TechCodeofHammurabi_ua.7a584021.webp";